import Vue from 'vue';
import Router from 'vue-router';
// import HelloWorld from '@/components/HelloWorld'
// import Reader from "@/pages/Reader"

import index from "@/pages/index";

import home from "@/pages/home";
import lists from "@/pages/lists";
import morePage from "@/pages/morePage";
import myBook from "@/pages/myBook";

import detail from "@/pages/detail";
import ebookDetail from "@/pages/ebookDetail";
import videoDetail from "@/pages/videoDetail";
import audioDetail from "@/pages/audioDetail";

import register from "@/pages/login/register";
import login from "@/pages/login/login";
import forget from "@/pages/login/forget";
import registerSuccess from "@/pages/login/success";

import my from "@/pages/me/my";
import personal from "@/pages/me/personal";
import nickName from "@/pages/me/nickName";
import setting from "@/pages/me/setting/setting";
import bindEmail from "@/pages/me/bindEmail";
import bindPhone from "@/pages/me/bindPhone";

import expensesRecord from "@/pages/me/expensesRecord";
import historyRecord from "@/pages/me/historyRecord";

import about from "@/pages/me/setting/about";
import help from "@/pages/me/setting/help";
import policy from "@/pages/me/setting/policy";
import useTerms from "@/pages/me/setting/useTerms";

import buy from "@/pages/buy/buy";
import buySuccess from "@/pages/buy/buySuccess";
import buyFail from "@/pages/buy/buyFail";

//import audioBook from "@/pages/audioBook";
//import videoList from "@/pages/videoList";
//import audioPlayer from "@/pages/audioPlayer";

import search from "@/pages/search/search";
import searchResult from "@/pages/search/searchResult";




Vue.use(Router)

let routes = [
  {path: '/', name: 'index', component: index},
  {path: '/wap', name: 'wap', component: index},
  {path: '/home', name: 'home', component: home,
    meta: {
      keepAlive: true //此页面需要缓存
    }
  },
  {path: '/ebookDetail', name: 'ebookDetail', component: ebookDetail},
  {path: '/videoDetail', name: 'videoDetail', component: videoDetail},
  {path: '/audioDetail', name: 'audioDetail', component: audioDetail},
  {path: '/morePage', name: 'morePage', component: morePage,
    meta: {
      keepAlive: true//此页面需要缓存
    }
  },
  //{path: '/audioBook', name: 'audioBook', component: audioBook},
  //{path: '/videoList', name: 'videoList', component: videoList},
  //ss{path: '/audioPlayer', name: 'audioPlayer', component: audioPlayer},
  {path: '/lists', name: 'lists',component: lists,
    meta: {
      keepAlive: true//此页面需要缓存
    }
  },
  {path: '/detail', name: 'detail', component: detail},
  {path: '/my', name: 'my', component: my},

  {path: '/personal', name: 'personal', component: personal},
  {path: '/nickName', name: 'nickName', component: nickName},
  {path: '/expensesRecord', name: 'expensesRecord', component: expensesRecord},
  {path: '/historyRecord', name: 'historyRecord', component: historyRecord},
  {path: '/setting', name: 'setting', component: setting},
  {path: '/about', name: 'about', component: about},
  {path: '/help', name: 'help', component: help},
  {path: '/policy', name: 'policy', component: policy},
  {path: '/useTerms', name: 'useTerms', component: useTerms},
  {path: '/myBook', name: 'myBook', component: myBook},
  {path: '/buy', name: 'buy', component: buy},
  {path: '/buySuccess', name: 'buySuccess', component: buySuccess},
  {path: '/buyFail', name: 'buyFail', component: buyFail},
  {path: '/bindEmail', name: 'bindEmail', component: bindEmail},
  {path: '/bindPhone', name: 'bindPhone', component: bindPhone},
  {path: '/register', name: 'register', component: register},
  {path: '/login', name: 'login', component: login},
  {path: '/forget', name: 'forget', component: forget},
  {path: '/registerSuccess', name: 'registerSuccess', component: registerSuccess},
  {path: '/search', name: 'search', component: search,
    meta: {
      keepAlive: true//此页面需要缓存
    }
  },
  {path: '/searchResult', name: 'searchResult', component: searchResult,
    meta: {
      keepAlive: true//此页面需要缓存
    }
  }
];


export default new Router({
  //mode: 'history', //调试关闭，开启后无法通过url地址栏跳转路由
  routes
});



// WEBPACK FOOTER //
// ./src/router/index.js